import React, { useState, useEffect } from 'react';
import CTABanner from '../components/landingPage/CTABanner';
import SocialMediaCTA from '../components/SocialMediaCTA';
import NewsSection from '../components/landingPage/NewsSection';

const OurWorkPage = () => {
  const [projects, setProjects] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/landmark-projects`);
        if (response.ok) {
          const data = await response.json();
          setProjects(data.projects);
        } else {
          setError('Failed to fetch landmark projects');
        }
      } catch (error) {
        setError('Error fetching landmark projects');
      }
      setIsLoading(false);
    };
    fetchProjects();
  }, []);

  if (isLoading) {
    return <div className="text-center my-10">Loading...</div>;
  }

  if (error) {
    return <div className="text-red-500 text-center my-10">{error}</div>;
  }

  return (
    <div className="container pt-40 mx-auto px-4 py-8">
        {/* <h1 className="text-4xl font-bold text-main-blue text-center mb-12 mt-20">Our Landmark Projects</h1> */}
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-main-blue text-center mb-8 sm:mb-12">
          Our Landmark Projects
        </h1>
        {projects.length === 0 ? (
          <p className="text-center text-gray-500">No landmark projects available at the moment.</p>
        ) : (
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-2">
            {projects.map((project) => (
              <div key={project.id} className="flex flex-col items-center p-4 border rounded-lg shadow-sm">
                {project.images && project.images.length > 0 && (
                  <img
                    src={`http://localhost:5000${project.images[0].imageUrl}`}
                    alt={project.title}
                    className="max-w-full h-auto"
                  />
                )}
                <h3 className="mt-4 text-xl font-semibold text-center">{project.title}</h3>
                <p className="text-gray-600 text-center mt-2">{project.description}</p>
              </div>
            ))}
          </div>
        )}
        <CTABanner className="my-12 " />
        <SocialMediaCTA className="my-12" />
        <NewsSection className="my-12" />
      </div>
 
  );
};

export default OurWorkPage;
